module.exports = __webpack_public_path__ + "static/img/index22.604449b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/index22.gif
// module id = yS/l
// module chunks = 0